import { FormattedMessage } from 'react-intl'

import { Content, ContentHeader } from 'components/v2/Content'
import Heading from 'components/v2/Heading'
import Card from '@10xLabs/react-web/components/Card'
import { NetworkStatus, useMutation, useQuery } from '@apollo/client'
import { EDIT_ANCILLARY } from 'features/Ancillaries/mutations-legacy'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router'
import { GTAncillary, GTChangeAncillaryInput } from 'gql/types.generated'
import { GET_ANCILLARY } from 'features/Ancillaries/queries-legacy'
import { useParams } from 'react-router-dom'
import EmptyState from 'components/v2/EmptyState'
import { Loader } from '@10xLabs/react-web/components/Loader'
import { Button } from 'components/v2/Button'
import { NewPreferredSeatsAncillaryForm } from 'features/Ancillaries/components/NewPreferredSeatsAncillaryForm'
import styled from 'styled-components'
import { INewPreferredSeatsAncillaryForm } from 'features/Ancillaries/components/NewPreferredSeatsAncillaryForm/types'
import { mapPreferredSeatsAncillaryToForm, mapPreferredSeatsAncillaryToMutation } from 'resolvers/ancillaries'

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

const EditLuggaeAncillary = (): ReactElement => {
  let content = null
  const navigate = useNavigate()
  const { ancillaryId } = useParams()
  const {
    data,
    loading: getAncillaryLoading,
    error: getAncillaryError,
    networkStatus,
    refetch
  } = useQuery<{ ancillary: GTAncillary }>(GET_ANCILLARY, {
    variables: {
      input: {
        id: ancillaryId
      }
    }
  })
  const [editAncillary, { loading, error }] = useMutation(EDIT_ANCILLARY, {
    onCompleted: () => {
      navigate('/ancillaries/preferred-seats')
    }
  })
  const handleSubmit = (values: INewPreferredSeatsAncillaryForm): void => {
    const newAncillary = mapPreferredSeatsAncillaryToMutation(values)
    const input: GTChangeAncillaryInput = {
      id: ancillaryId as string,
      conditions: newAncillary.conditions
    }
    editAncillary({
      variables: {
        input
      }
    })
  }

  if (networkStatus === NetworkStatus.refetch || getAncillaryLoading) {
    content = (
      <Card.Content noHeader noFooter>
        <EmptyState.Container>
          <Loader />
        </EmptyState.Container>
      </Card.Content>
    )
  } else if (getAncillaryError || !data?.ancillary) {
    content = (
      <Card.Content noHeader noFooter>
        <EmptyState.Container>
          <EmptyState.Description>
            <FormattedMessage
              id="ancillaries.edit.error.description"
              defaultMessage="There was an error while loading the ancillary"
            />
          </EmptyState.Description>

          <EmptyState.Action>
            <Button
              onClick={(): void => {
                refetch()
              }}
            >
              <FormattedMessage id="ancillaries.edit.error.action" defaultMessage="Reload your the ancillary" />
            </Button>
          </EmptyState.Action>
        </EmptyState.Container>
      </Card.Content>
    )
  } else {
    content = (
      <NewPreferredSeatsAncillaryForm
        onSubmit={handleSubmit}
        ancillary={mapPreferredSeatsAncillaryToForm(data.ancillary)}
        loading={loading}
        error={error}
        isEditView
      />
    )
  }
  return (
    <Container>
      <Content>
        <ContentHeader>
          <Heading.H3>
            <FormattedMessage id="preferredSeatsAncillary.edit.title" defaultMessage="Preferred seats" />
          </Heading.H3>
        </ContentHeader>
        <section>
          <Card.Container>{content}</Card.Container>
        </section>
      </Content>
    </Container>
  )
}

export default EditLuggaeAncillary
